import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { IoDiceOutline } from 'react-icons/io5';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
const DegenModeSwitchModal = () => {
  const [isSwitched, setIsSwitch] = useState(false);
  const _handleToggleModal = () => {
    setIsSwitch(!isSwitched);
    return;
  };
  return <Dialog open={isSwitched} onOpenChange={_handleToggleModal} data-sentry-element="Dialog" data-sentry-component="DegenModeSwitchModal" data-sentry-source-file="DegenModeSwitchModal.tsx">
      <DialogTrigger asChild data-sentry-element="DialogTrigger" data-sentry-source-file="DegenModeSwitchModal.tsx">
        <div className='flex gap-2 w-[148px] h-[46px] p-4 items-center' role='button' aria-label='Open Degen Modal'>
          <Label className='' data-sentry-element="Label" data-sentry-source-file="DegenModeSwitchModal.tsx">Degen:</Label>
          <Switch checked={isSwitched} onCheckedChange={setIsSwitch} className='border border-genius-indigo' data-sentry-element="Switch" data-sentry-source-file="DegenModeSwitchModal.tsx" />
        </div>
      </DialogTrigger>
      <DialogContent className={`dialog-content max-h-[522px] max-w-[572px] w-full h-full p-4 rounded-[20px] border-2 border-genius-blue`} aria-labelledby='dialog-title' data-sentry-element="DialogContent" data-sentry-source-file="DegenModeSwitchModal.tsx">
        <DialogTitle className='hidden' id='dialog-title' data-sentry-element="DialogTitle" data-sentry-source-file="DegenModeSwitchModal.tsx" />
        <div className='purple-gradient flex flex-col gap-2 p-4 w-full justify-between items-center leading-[20px]'>
          <p className='text-[24px]'>VIPs Only</p>
          <IoDiceOutline className='w-[76px] h-[74px]' data-sentry-element="IoDiceOutline" data-sentry-source-file="DegenModeSwitchModal.tsx" />
          <p className='w-[400px] text-center text-genius-gradient-dark'>{`Genius Pro is for degens and professional traders alike. We're building the most powerful chain-abstracted trading platform ever. We want your input, if you qualify to give input.`}</p>
          <Button variant='blue' className='w-full rounded-full text-[14px] h-[56px]' aria-label='Request Access' data-sentry-element="Button" data-sentry-source-file="DegenModeSwitchModal.tsx">
            Request Access
          </Button>
        </div>
      </DialogContent>
    </Dialog>;
};
export default DegenModeSwitchModal;